import { FormModel } from 'components/Form';
import { Validators } from 'utils/validators';

export const CityPotentialForm = (strings: any, cityList: any[]): FormModel[] => {
  return [
    {
      label: strings.sales_management_branch_competitions_city,
      value: '',
      size: 'medium',
      type: 'drop-down',
      variant: 'outlined',
      placeholder: '',
      field: 'city',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 12, md: 6, sm: 4 },
      required: true,
      options: cityList,
    },
    {
      label: strings.sales_management_branch_competitions_region,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'text',
      variant: 'outlined',
      placeholder: '',
      field: 'region',
      validators: [],
      responsive: { xs: 12, md: 6, sm: 8 },
      required: false,
    },
    // -----------------------------------------------------------------------------
    {
      label: strings.sales_management_branch_competitions_total_city_potential_section,
      value: null,
      type: 'section',
      placeholder: '',
      field: null,
      autoFocus: true,
      validators: [],
      required: false,
      responsive: { xs: 12 },
    },
    {
      label: strings.sales_management_branch_competitions_my_potential_nights,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'roomNights',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 6, sm: 6, md: 3 },
      required: false,
    },
    {
      label: strings.sales_management_branch_competitions_my_potential_rate,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'roomRevenue',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 6, sm: 6, md: 3 },
      required: false,
    },
    {
      label: strings.sales_management_branch_competitions_my_potential_event_count,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'eventCount',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 6, sm: 6, md: 3 },
      required: false,
    },
    {
      label: strings.sales_management_branch_competitions_my_potential_event_rate,
      value: '',
      size: 'medium',
      type: 'text',
      typeValue: 'number',
      variant: 'outlined',
      placeholder: '',
      field: 'eventRevenue',
      validators: [{ check: Validators.validateMandatoryField }],
      responsive: { xs: 6, sm: 6, md: 3 },
      required: false,
    },
    // -----------------------------------------------------------------------------
    // {
    //   label: strings.sales_management_branch_competitions_fit_section,
    //   value: null,
    //   type: 'section',
    //   placeholder: '',
    //   field: null,
    //   autoFocus: true,
    //   validators: [],
    //   required: false,
    //   responsive: { xs: 12 },
    // },
    // {
    //   label: strings.sales_management_branch_competitions_fit_nights,
    //   value: '',
    //   size: 'medium',
    //   type: 'text',
    //   typeValue: 'number',
    //   variant: 'outlined',
    //   placeholder: '',
    //   field: 'fitRoomNights',
    //   validators: [{ check: Validators.validateMandatoryField }],
    //   responsive: { xs: 6, sm: 6 },
    //   required: false,
    // },
    // {
    //   label: strings.sales_management_branch_competitions_fit_room_potential,
    //   value: '',
    //   size: 'medium',
    //   type: 'text',
    //   typeValue: 'number',
    //   variant: 'outlined',
    //   placeholder: '',
    //   field: 'fitRoomPotential',
    //   validators: [{ check: Validators.validateMandatoryField }],
    //   responsive: { xs: 6, sm: 6 },
    //   required: false,
    // },
  ];
};
